
export default
  [
    {
      title: "الرئيسية",
      route: 'home',
      icon: 'HomeIcon',
    },
    {
      title: "إنشاء ملف إنجاز",
      route: 'create',
      icon: 'PlusIcon'
    },
    {
      title: "عرض ملفات الإنجاز",
      route: 'list',
      icon: 'ListIcon'
    },
    {
      title: "الإشتراك في النظام",
      route: 'subscribe',
      icon: 'CheckSquareIcon'
    },
  ];
